<template>
    <a>
        <i class="fa fa-trash" v-if="inactive" v-on:click="toggleInactiveState"></i>
        <i class="fa fa-check" v-if="!inactive" v-on:click="confirm"></i>
        <i class="fa fa-times" v-if="!inactive" v-on:click="toggleInactiveState"></i>
    </a>
</template>

<script>
    export default {
        name: "TinyDeleteConfirm",
        props: {
            id: String
        },
        data: function() {
            return {
                inactive: true
            };
        },
        methods: {
            toggleInactiveState: function() {
                this.inactive = !this.inactive;
            },
            confirm: function() {
                this.$emit("confirm", this.id);
            }
        }
    }
</script>

<style scoped>
    a {
        cursor: pointer;
    }

    i {
        color: #999;
        -webkit-transition: color 0.2s ease-in-out;
        -moz-transition: color 0.2s ease-in-out;
        -ms-transition: color 0.2s ease-in-out;
        -o-transition: color 0.2s ease-in-out;
        transition: color 0.2s ease-in-out;
    }

    .fa-times {
        margin-left: 8px;
    }
    .fa-times, .fa-check {
        line-height: 1.1rem;
        font-size: 1.1rem;
    }

    .fa-trash:hover {
        color: #d43f3a;
    }
    .fa-times:hover {
        color: #bd423e;
    }
    .fa-check:hover {
        color: #2ea84d;
    }

</style>
